import React from "react";
import SidebarThemeSettings from "../components/SidebarThemeSettings";
import axiosInstance from "../components/api/axiosInstance";
import { updateClientPortalProfile } from "../utils/authStorage";
import { getPortalSession } from "./portalSession";
import "../assets/css/Settings.css";

async function saveSidebarThemeToAccount(theme) {
  updateClientPortalProfile({ ...getPortalSession(), Sidebar_Theme: theme });
  try {
    await axiosInstance.put("/client/me", { Sidebar_Theme: theme });
  } catch (_) {
    /* still applied on this device */
  }
}

function TenantSettings() {
  return (
    <div className="cportal-page">
      <div className="cportal-page-head">
        <div>
          <h1>Settings</h1>
        </div>
      </div>

      <div className="settings-card">
        <SidebarThemeSettings scope="portal" onChange={saveSidebarThemeToAccount} />
      </div>
    </div>
  );
}

export default TenantSettings;
